/**
 * Docker/프로덕션: REACT_APP_API_BASE_URL="" → 동일 출처 상대 경로 `/api` 사용
 * 로컬 CRA: 미설정 시 프록시용 http://localhost:3000
 */
export function getApiBaseUrl(): string {
  const v = process.env.REACT_APP_API_BASE_URL;
  if (v === undefined || v === null) {
    return 'http://localhost:3000';
  }
  return v;
}
